/**
 * 用户模块
 */

export default {
  // 用户-信息-手机
  userInfoPhone: `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_PREFIX_STR}/user/info/phone`,
};
